import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useUrlManager = (cardData) => {
    const location = useLocation();
    
    useEffect(() => {
        if (!cardData?.companyname) return;

        const companyUrl = `/company/${cardData.companyname.toLowerCase().replace(/\s+/g, '_')}`;
        const isHomePage = location.pathname === '/';
        const isTestPage = location.pathname.startsWith('/test/');
        const isCategoryPage = /^\/(discover|trending|just_in|launched)\//.test(location.pathname);
        const isCompanyPage = location.pathname.startsWith('/company/');
        
        // Guardar la URL si estamos en home, test, páginas de categoría o páginas de compañía
        if (isHomePage || isTestPage || isCategoryPage || isCompanyPage) {
            window.history.replaceState(
                { 
                    previousUrl: location.pathname,
                    isOverlay: true 
                },
                '',
                companyUrl
            );
        }
        
        return () => {
            // Restaurar la URL original cuando se desmonta
            if (isHomePage || isTestPage || isCategoryPage || isCompanyPage) {
                window.history.replaceState(
                    null,
                    '',
                    location.pathname
                );
            }
        };
    }, [cardData, location.pathname]);
};